import React, { useReducer } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom'
import routes from "@/common/routes"
import Head from "@/components/Head/index"
import Footer from "@/components/Footer/index"
import "@/App.scss"
import ScrollToTop from "@/scrollToTop"
import AffixTop from '@/components/AffixTop';
import { reducer, defaultState, Context } from "@/models/home"

function App () {
  const [state, dispatch] = useReducer(reducer, defaultState)

  return (
    <Router>
      <ScrollToTop>
        <div className="App">
          <AffixTop />
          <Context.Provider value={{ state, dispatch: dispatch }}>
            <Head />
            {/* 路由配置 */}
            {
              routes.map((item, idx) => {
                if (item.exact) {
                  return <Route key={idx} exact path={item.path} component={item.component}></Route>
                } else {
                  return <Route key={idx} path={item.path} component={item.component}></Route>
                }
              })
            }
            <Footer />
          </Context.Provider>
        </div>
      </ScrollToTop>
    </Router>
  );
}

export default App;
